export const SUGGEST_PRIZE_ID = 'SuggestPrize';